<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
          <b>OKKO.fun</b> &middot; 2017-2023 &middot; &copy;
          <b-tooltip
            label="CTOON.network"
            type="is-dark"
            dashed
            animated
          >
            CTOON
          </b-tooltip>
          <br>
          <b>OK K.O.! Let's Be Heroes</b> &middot; 2017 &middot; TM & &copy;
          <b-tooltip
            label="A WB/Discovery Company"
            type="is-dark"
            dashed
            animated
          >
            Cartoon Network
          </b-tooltip>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter'
}
</script>
